import React from "react"
import { Table } from "react-bootstrap"
import roles from "../data/roles.json"
import UAI from "../UAI"
import "./PermisosAtributo.css"

const PermisosAtributo = (props) => {
  let pasos = [1, 2, 3, 4, 5, 6]

  if (!props.permisos) {
    return <div>ERROR!</div>
  }
  return (
    <>
      <Table className={props.small ? "permisosatributo" : "permisosatributobig"}>
        <thead>
          <tr>
            <th></th>
            {pasos.map((paso) => {
              return <th key={paso}>{paso}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {roles.map((rol, idx) => {
            if (rol === "Administrador") {
              return null
            }
            return (
              <tr key={idx}>
                <td title={rol}>{UAI.iconosRoles[rol]}{props.small ? "" : " " + rol}</td>
                {pasos.map((paso) => {
                  let _permiso = props.permisos.find((permiso) => {
                    return permiso.PasoId === paso && permiso.Perfil === rol
                  })
                  if (_permiso) {
                    _permiso = _permiso.Permiso
                  } else {
                    _permiso = "Oculto"
                  }
                  return (
                    <td
                      key={idx + paso}
                      className={_permiso}
                      title={_permiso}
                    ></td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}

export default PermisosAtributo
